module.exports = "./img/a20a8d2fa316e77da8d72d1cda73cbdb.jpg";